import { createStore } from 'vuex';

import { auth } from '@speechki-frontend/core/auth/store';
import { ui } from '@speechki-frontend/core/misc/store';

export default createStore({
    modules: {
        ui,
        auth
    }
});
